import { render, staticRenderFns } from "./BtLoader.vue?vue&type=template&id=7b890e64&lang=pug&"
import script from "./BtLoader.vue?vue&type=script&lang=js&"
export * from "./BtLoader.vue?vue&type=script&lang=js&"
import style0 from "./BtLoader.vue?vue&type=style&index=0&id=7b890e64&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports